import {useTranslation} from 'react-i18next';

import GoogleLogo from 'assets/logos/google.jpeg';
import PapagoLogo from 'assets/logos/papago.png';
import AliLogo from 'assets/logos/ali.png';
import DeeplLogo from 'assets/logos/deepl.png';
import ChatgptLogo from 'assets/logos/chatgpt.png';
// import BaiduLogo from 'assets/logos/baidu.png';

/** 语言条目：name 为中文展示名，nameEn 为英文展示名（英文环境由 useLocalizedLan 覆盖）。
 * 数据来源：业务方《象寄翻译支持语言列表》docx（2026-09）——图片翻译源 11/目标 53、视频翻译源 4/目标 25。
 * 四组列表均为纯清单（语种+代码），不带示例句与文本引擎矩阵（新数据源未提供，且引擎选择见上方引擎卡区）。 */
export interface LanItem {
  code: string;
  name: string;
  nameEn: string;
}

export const imageTargetLan: LanItem[] = [
  {code: 'AR', name: '阿拉伯语', nameEn: 'Arabic'},
  {code: 'BG', name: '保加利亚语', nameEn: 'Bulgarian'},
  {code: 'BN', name: '孟加拉语', nameEn: 'Bengali'},
  {code: 'CHS', name: '中文(简体)', nameEn: 'Chinese(Simplified)'},
  {code: 'CHT', name: '中文(繁体)', nameEn: 'Chinese(Traditional)'},
  {code: 'CKB', name: '中库尔德语(索拉尼语)', nameEn: 'Central Kurdish(Sorani)'},
  {code: 'CSY', name: '捷克语', nameEn: 'Czech'},
  {code: 'DA', name: '丹麦语', nameEn: 'Danish'},
  {code: 'DEU', name: '德语', nameEn: 'German'},
  {code: 'EL', name: '希腊语', nameEn: 'Greek'},
  {code: 'ENG', name: '英语', nameEn: 'English'},
  {code: 'ESP', name: '西班牙语', nameEn: 'Spanish'},
  {code: 'ET', name: '爱沙尼亚语', nameEn: 'Estonian'},
  {code: 'FA', name: '波斯语', nameEn: 'Persian'},
  {code: 'FI', name: '芬兰语', nameEn: 'Finnish'},
  {code: 'FIL', name: '菲律宾语', nameEn: 'Filipino'},
  {code: 'FRA', name: '法语', nameEn: 'French'},
  {code: 'GU', name: '古吉拉特语', nameEn: 'Gujarati'},
  {code: 'HE', name: '希伯来语', nameEn: 'Hebrew'},
  {code: 'HI', name: '印地语', nameEn: 'Hindi'},
  {code: 'HR', name: '克罗地亚语', nameEn: 'Croatian'},
  {code: 'HUN', name: '匈牙利语', nameEn: 'Hungarian'},
  {code: 'ID', name: '印度尼西亚语', nameEn: 'Indonesian'},
  {code: 'ITA', name: '意大利语', nameEn: 'Italian'},
  {code: 'JPN', name: '日语', nameEn: 'Japanese'},
  {code: 'JW', name: '爪哇语', nameEn: 'Javanese'},
  {code: 'KOR', name: '韩语', nameEn: 'Korean'},
  {code: 'LO', name: '老挝语', nameEn: 'Lao'},
  {code: 'LT', name: '立陶宛语', nameEn: 'Lithuanian'},
  {code: 'LV', name: '拉脱维亚语', nameEn: 'Latvian'},
  {code: 'MR', name: '马拉地语', nameEn: 'Marathi'},
  {code: 'MS', name: '马来语', nameEn: 'Malay'},
  {code: 'MY', name: '缅甸语', nameEn: 'Burmese'},
  {code: 'NLD', name: '荷兰语', nameEn: 'Dutch'},
  {code: 'NO', name: '挪威语', nameEn: 'Norwegian'},
  {code: 'PLK', name: '波兰语', nameEn: 'Polish'},
  {code: 'PT', name: '葡萄牙语', nameEn: 'Portuguese'},
  {code: 'PTB', name: '葡萄牙语(巴西)', nameEn: 'Portuguese(Brazil)'},
  {code: 'ROM', name: '罗马尼亚语', nameEn: 'Romanian'},
  {code: 'RUS', name: '俄语', nameEn: 'Russian'},
  {code: 'SK', name: '斯洛伐克语', nameEn: 'Slovak'},
  {code: 'SL', name: '斯洛文尼亚语', nameEn: 'Slovenian'},
  {code: 'SV', name: '瑞典语', nameEn: 'Swedish'},
  {code: 'SW', name: '斯瓦希里语', nameEn: 'Swahili'},
  {code: 'TA', name: '泰米尔语', nameEn: 'Tamil'},
  {code: 'TE', name: '泰卢固语', nameEn: 'Telugu'},
  {code: 'TG', name: '塔吉克语', nameEn: 'Tajik'},
  {code: 'TH', name: '泰语', nameEn: 'Thai'},
  {code: 'TL', name: '他加禄语(菲律宾)', nameEn: 'Tagalog'},
  {code: 'TRK', name: '土耳其语', nameEn: 'Turkish'},
  {code: 'UK', name: '乌克兰语', nameEn: 'Ukrainian'},
  {code: 'UR', name: '乌尔都语', nameEn: 'Urdu'},
  {code: 'VIN', name: '越南语', nameEn: 'Vietnamese'},
];

export const imageSourceLan: LanItem[] = [
  {code: 'CHS', name: '中文(简体)', nameEn: 'Chinese(Simplified)'},
  {code: 'CHT', name: '中文(繁体)', nameEn: 'Chinese(Traditional)'},
  {code: 'DEU', name: '德语', nameEn: 'German'},
  {code: 'ENG', name: '英语', nameEn: 'English'},
  {code: 'ESP', name: '西班牙语', nameEn: 'Spanish'},
  {code: 'JPN', name: '日语', nameEn: 'Japanese'},
  {code: 'KOR', name: '韩语', nameEn: 'Korean'},
  {code: 'PT', name: '葡萄牙语', nameEn: 'Portuguese'},
  {code: 'ROM', name: '罗马尼亚语', nameEn: 'Romanian'},
  {code: 'RUS', name: '俄语', nameEn: 'Russian'},
  {code: 'VIN', name: '越南语', nameEn: 'Vietnamese'},
];

export const videoTargetLan: LanItem[] = [
  {code: 'AR', name: '阿拉伯语', nameEn: 'Arabic'},
  {code: 'CHS', name: '中文(简体)', nameEn: 'Chinese(Simplified)'},
  {code: 'BN', name: '孟加拉语', nameEn: 'Bengali'},
  {code: 'CHT', name: '中文(繁体)', nameEn: 'Chinese(Traditional)'},
  {code: 'DEU', name: '德语', nameEn: 'German'},
  {code: 'ENG', name: '英语', nameEn: 'English'},
  {code: 'ESP', name: '西班牙语', nameEn: 'Spanish'},
  {code: 'FRA', name: '法语', nameEn: 'French'},
  {code: 'HI', name: '印地语', nameEn: 'Hindi'},
  {code: 'HUN', name: '匈牙利语', nameEn: 'Hungarian'},
  {code: 'ID', name: '印度尼西亚语', nameEn: 'Indonesian'},
  {code: 'ITA', name: '意大利语', nameEn: 'Italian'},
  {code: 'JPN', name: '日语', nameEn: 'Japanese'},
  {code: 'KOR', name: '韩语', nameEn: 'Korean'},
  {code: 'MS', name: '马来语', nameEn: 'Malay'},
  {code: 'MY', name: '缅甸语', nameEn: 'Burmese'},
  {code: 'NLD', name: '荷兰语', nameEn: 'Dutch'},
  {code: 'PLK', name: '波兰语', nameEn: 'Polish'},
  {code: 'PTB', name: '葡萄牙语(巴西)', nameEn: 'Portuguese(Brazil)'},
  {code: 'ROM', name: '罗马尼亚语', nameEn: 'Romanian'},
  {code: 'RUS', name: '俄语', nameEn: 'Russian'},
  {code: 'TH', name: '泰语', nameEn: 'Thai'},
  {code: 'TL', name: '他加禄语(菲律宾)', nameEn: 'Tagalog'},
  {code: 'TRK', name: '土耳其语', nameEn: 'Turkish'},
  {code: 'VIN', name: '越南语', nameEn: 'Vietnamese'},
];

export const videoSourceLan: LanItem[] = [
  {code: 'CHS', name: '中文(简体)', nameEn: 'Chinese(Simplified)'},
  {code: 'CHT', name: '中文(繁体)', nameEn: 'Chinese(Traditional)'},
  {code: 'ENG', name: '英语', nameEn: 'English'},
  {code: 'JPN', name: '日语', nameEn: 'Japanese'},
];

export const engines = [
  {
    key: 'google',
    name: 'Google',
    thumbnail: GoogleLogo,
    url: 'https://translate.google.cn/',
  },
  {
    key: 'papago',
    name: 'Papago',
    thumbnail: PapagoLogo,
    url: 'https://papago.naver.com/',
  },
  {
    key: 'ali',
    name: 'Ali',
    thumbnail: AliLogo,
    url: 'https://www.alifanyi.com/',
  },
  {
    key: 'deepl',
    name: 'DeepL',
    thumbnail: DeeplLogo,
    url: 'https://www.deepl.com/translator',
  },
  {
    key: 'chatgpt',
    name: 'ChatGPT',
    thumbnail: ChatgptLogo,
    url: 'https://chatgpt.com/',
  },
  // {
  //   key: 'baidu',
  //   name: 'Baidu',
  //   thumbnail: BaiduLogo,
  //   url: 'https://fanyi.baidu.com/',
  // },
];

/**
 * i18n 数据工厂：英文环境下用 nameEn 覆盖 name，其余语言原样返回。
 * 必须在组件函数体内调用（useTranslation 约束），使用方见 Languages/index.tsx。
 */
export const useLocalizedLan = (list: LanItem[]): LanItem[] => {
  const {i18n} = useTranslation('languages');
  if (i18n.language !== 'en') return list;

  return list.map((lan) => ({...lan, name: lan.nameEn}));
};
